import { STORES_DOC_TABS } from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { MoveListPage } from "@/features/stores/components/move-list-page";

export const Route = createFileRoute("/_app/stores/counts/")({
  validateSearch: z.object({
    tab: z.enum(STORES_DOC_TABS).default("draft"),
    from: z.string().optional(),
    to: z.string().optional(),
    page: z.number().int().min(1).default(1),
  }),
  beforeLoad: () => {
    if (!useAuth.getState().can("stores.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <MoveListPage
      which="counts"
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
